import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import MemberStates from './pages/MemberStates/MemberStates';
import News from './pages/News/News';
import NewsDetail from './pages/News/NewsDetail';
import Contact from './pages/Contact/Contact';
import Map from './pages/Map/Map';
import Home2 from './pages/Home/Home2';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import PrivacyPolicyEn from './pages/PrivacyPolicy/PrivacyPolicyEn';

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Router basename="/turkicsilkroad">
          <div style={styles.app}>
            <Header />
            <main style={styles.main}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/home2" element={<Home2 />} />
                <Route path="/about" element={<About />} />
                <Route path="/member-states" element={<MemberStates />} />
                <Route path="/news" element={<News />} />
                <Route path="/news/:id" element={<NewsDetail />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/map" element={<Map />} />
                <Route path="/turkicsilkroad-gizlilik-politikasi" element={<PrivacyPolicy />} />
                <Route path="/turkicsilkroad-privacy-policy" element={<PrivacyPolicyEn />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  );
}

const styles = {
  app: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    color: '#333',
    overflowX: 'hidden',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    flex: 1,
  },
};

export default App;
